'use strict';

var TeamUtils = require('../TeamUtils');
var FirebaseUtils = require('../FirebaseUtils');

var CreateTeamInvite = {
  getSchema: function getSchema() {
    return {
      "definitions": {
        "team": {
          "type": "object",
          "properties": {
            "id": { "type": "string" },
            "displayName": { "type": "string" }
          },
          "required": ["id", "displayName"]
        },
        "invitationOwner": {
          "type": "object",
          "properties": {
            "id": { "type": "string" },
            "role": { "type": "string" },
            "displayName": { "type": "string" }
          },
          "required": ["id", "role", "displayName"]
        },
        "invitee": {
          "type": "object",
          "properties": {
            "id": { "type": "string" },
            "displayName": { "type": "string" },
            "fullName": { "type": "string" },
            "role": { "type": "string" }
          },
          "required": ["id", "displayName"]
        },
        "invites": {
          "items": {
            "type": "object",
            "properties": {
              "team": { "$ref": "#/definitions/team" },
              "invitationOwner": { "$ref": "#/definitions/invitationOwner" },
              "invitee": { "$ref": "#/definitions/invitee" }
            },
            "required": ["team", "invitationOwner", "invitee"]
          }
        }
      },

      "properties": {
        "invites": { "$ref": "#/definitions/invites" }
      },
      "required": ["invites"]
    };
  },

  execute: function execute(fbApp, body, timestamp, callback) {
    // Preparing info from firebase
    var updates = {};

    body.invites.forEach(function (invite) {
      // Add the user to the team
      TeamUtils.addUserToTeam(updates, timestamp, invite.team, invite.invitee, {
        role: invite.invitee.role,
        access: "invitee"
      });

      // Create the invite
      TeamUtils.createTeamInvite(updates, timestamp, invite.team, invite.invitationOwner, invite.invitee);

      updates['queue/joinTeam/' + invite.invitee.id + '/' + invite.team.id] = {
        displayName: invite.invitee.displayName
      };
    });

    // Save to firebase
    FirebaseUtils.saveToFirebase(fbApp.database().ref(), updates, callback);
  }
};

module.exports = CreateTeamInvite;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/functions/CreateTeamInvite.js
// module id = 1035
// module chunks = 0